import React from 'react';
import { FormControl, InputLabel, Select } from "@mui/material";

const FormControlInput = ({
    inputLabel,
    label,
    value,
    onChange,
    ...options
}) => {
    return (
        <FormControl sx={{ m: 1, minWidth: 200 }} size="small">
            <InputLabel id="open-select-id">{inputLabel}</InputLabel>
            <Select
                labelId="open-select-id"
                id="controlled-open-select"
                label={label}
                value={value} // Controlled component value
                onChange={onChange}
                {...options}
            >
            </Select>
        </FormControl>
    );
}

export default FormControlInput;